import React, { useState, useEffect, useCallback } from "react";
import Switch from "components/Switch";
import Tag from "components/Tag";
import Icon from "components/Icon";
import ColorPicker from "components/ColorPicker";
import Dropdown from "components/Dropdown";
import useBindToContext from "hooks/useBindToContext";
import styled from "styled-components";
import classNames from "lib/classNames";
import _ from "lodash";
import Editor, { DiffEditor, useMonaco, loader } from "@monaco-editor/react";

const CodeEditor = ({
  disabled,
  onFocus,
  onBlur,
  inputRef,
  value,
  autofocus,
  placeholder,
  className,
  onChange,
  BindToContext,
  placeholder_color,
  border_color,
  validation = true,
  getError = null,
  specificValidation = null,
  isFlex,
  row = 2,
  language,
}) => {
  const [BindedValue, BindedOnChange, hasError, onRender] = useBindToContext(
    BindToContext,
    value,
    onChange,
    specificValidation,
    getError,
    validation
  );

  const handleChange = (value) => {
    BindedOnChange(value);
  };
  return (
    <div
      className={classNames(
        "w-full rounded-md relative overflow-hidden h-64 mt-2"
      )}
    >
      <Editor
        height="100%"
        theme="light"
        language={language}
        value={BindedValue}
        onChange={handleChange}
        defaultValue={placeholder}
      />
    </div>
  );
};

CodeEditor.defaultProps = {
  disabled: false,
  style: {},
  onEnter: false,
  onFocus: false,
  onBlur: false,
  onKeyDown: false,
  inputRef: null,
  BindToContext: null,
  dispatch: null,
  placeholder: "",
  withSwitch: false,
  withNumber: false,
  withDropdown: false,
  value: undefined,
  className: "",
  iconFirst: false,
  placeholder_color: null,
  border_color: null,
  max: null,
  min: null,
};

export default CodeEditor;
